define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaTargetStorageTypeDomain = void 0;
    class WaTargetStorageTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaTargetStorageTypeDomain.StorageTanks, value: "Storage Tanks" },
                    { key: WaTargetStorageTypeDomain.ExcavatedTankTurkeysNest, value: "Excavated Tank (turkey's nest)" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaTargetStorageTypeDomain.StorageTanks] = 0;
                this.KeyIndex[WaTargetStorageTypeDomain.ExcavatedTankTurkeysNest] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Storage Tanks"] = 0;
                this.ValueIndex["Excavated Tank (turkey's nest)"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaTargetStorageTypeDomain = WaTargetStorageTypeDomain;
    Object.defineProperty(WaTargetStorageTypeDomain, "StorageTanks", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaTargetStorageTypeDomain, "ExcavatedTankTurkeysNest", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaTargetStorageTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
